<p-inputnumber
    class="w-full"
    [(ngModel)]="value"
    (ngModelChange)="handleChange()"
    [disabled]="disabled"
    [showButtons]="true"
    buttonLayout="horizontal"
    mode="decimal"
    [min]="1"
    spinnerMode="horizontal"
    [inputStyle]="{ width: '100%', height: '100%' }"
>
    <ng-template #incrementbuttonicon>
        <svg class="action-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.1 5.1H7.5C7.34087 5.1 7.18826 5.03679 7.07574 4.92426C6.96321 4.81174 6.9 4.65913 6.9 4.5V0.9C6.9 0.661305 6.80518 0.432387 6.6364 0.263604C6.46761 0.0948212 6.2387 0 6 0C5.76131 0 5.53239 0.0948212 5.3636 0.263604C5.19482 0.432387 5.1 0.661305 5.1 0.9V4.5C5.1 4.65913 5.03679 4.81174 4.92426 4.92426C4.81174 5.03679 4.65913 5.1 4.5 5.1H0.9C0.661305 5.1 0.432387 5.19482 0.263604 5.3636C0.0948212 5.53239 0 5.76131 0 6C0 6.2387 0.0948212 6.46761 0.263604 6.6364C0.432387 6.80518 0.661305 6.9 0.9 6.9H4.5C4.65913 6.9 4.81174 6.96321 4.92426 7.07574C5.03679 7.18826 5.1 7.34087 5.1 7.5V11.1C5.1 11.3387 5.19482 11.5676 5.3636 11.7364C5.53239 11.9052 5.76131 12 6 12C6.2387 12 6.46761 11.9052 6.6364 11.7364C6.80518 11.5676 6.9 11.3387 6.9 11.1V7.5C6.9 7.34087 6.96321 7.18826 7.07574 7.07574C7.18826 6.96321 7.34087 6.9 7.5 6.9H11.1C11.3387 6.9 11.5676 6.80518 11.7364 6.6364C11.9052 6.46761 12 6.2387 12 6C12 5.76131 11.9052 5.53239 11.7364 5.3636C11.5676 5.19482 11.3387 5.1 11.1 5.1Z"
                fill="currentColor"
            />
        </svg>
    </ng-template>
    <ng-template #decrementbuttonicon>
        <svg class="action-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.098 6.89998H0.898047C0.659352 6.89998 0.430434 6.80515 0.261651 6.63637C0.092868 6.46759 -0.00195312 6.23867 -0.00195312 5.99998C-0.00195312 5.76128 0.092868 5.53236 0.261651 5.36358C0.430434 5.1948 0.659352 5.09998 0.898047 5.09998H11.098C11.3367 5.09998 11.5657 5.1948 11.7344 5.36358C11.9032 5.53236 11.998 5.76128 11.998 5.99998C11.998 6.23867 11.9032 6.46759 11.7344 6.63637C11.5657 6.80515 11.3367 6.89998 11.098 6.89998Z"
                fill="currentColor"
            />
        </svg>
    </ng-template>
</p-inputnumber>
